// extracted by mini-css-extract-plugin
module.exports = {"maskedKey":"MaskedId_maskedKey__3IlVR","revealed":"MaskedId_revealed__OmlDj","copyTopIcon":"MaskedId_copyTopIcon__DfhzQ"};